import { Divider as AntDivider, Typography } from 'antd';
import styled from 'styled-components';
import { ProductiveHeading07 } from 'components/styles';

export const SectionContainer = styled.div`
  padding: var(--spacing-04) 0px var(--spacing-08);
`;

export const SectionTitleWrapper = styled.div`
  span {
    ${ProductiveHeading07};
  }
  margin-bottom: var(--spacing-04);
`;

export const Divider = styled(AntDivider)`
  &&.ant-divider-with-text-left::before {
    display: none;
  }

  .ant-divider-inner-text {
    padding-left: 0;
  }
`;

export const Label = styled(Typography.Text)<{ $hasIcon?: boolean }>`
  width: ${({ $hasIcon }) => ($hasIcon ? '112px' : '128px')};
`;
